import React, {useState, useEffect} from "react";
import {Button, Paper, Box, Autocomplete, TextField, Typography} from '@mui/material';
import Header from "../Common/Header/Header";
import Sidenav from "../Common/Sidenav/Sidenav";
import commonService from "../../services/common-service";
import Spinner from "../../shared/Spinner";
import SnackAlert from "../../shared/SnackAlert";
import { useParams } from "react-router-dom";
import * as XLSX from "xlsx";

export default function ExportsGrpTar() {
    const {domain} = useParams()
    const [installations, setInstallations] = useState([]);
    const [data, setData] = useState({});
    const [inputField, setInputField] = useState({});
    const [selectedIns, setSelectedIns] = useState(null);
    const [spinner, setSpinner] = React.useState(false);
    const [alert, setAlert] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [severity, setSeverity] = React.useState('');
    
    const handleChange=(e) => {
        setInputField({...inputField, [e.target.name]: e.target.value});
    }

    const getInstalltions=async() => {
        setSpinner(true);
        const user = JSON.parse(sessionStorage.getItem('userLogged'));
        let body = {domain: domain};
        if(user.email == "cwpadmin"){
            body.ins_description = 'cwp'
        }
        const res = await commonService.get_installtions(body);
        setInstallations(res.data);
        setSpinner(false);
    }

    const onInsSelect=async(newValue) => {
        setSelectedIns(newValue);
    }

    const handleSubmit=async(e) => {
        e.preventDefault();
        setSpinner(true);
        inputField['ins_id'] = selectedIns.ins_id
        inputField['domain'] = domain;
        const response = await commonService.getGroupsAndTariffs(inputField);
        setData(response);
        if (allArraysEmpty(response)) {
            setMsg("No record found with this installation.");
            setSeverity('error');
            setAlert(true);
        }
        setSpinner(false);
    }

    const allArraysEmpty = (data) =>
        Object.values(data).every(
            (value) => Array.isArray(value) && value.length === 0
    );

    const exportToExcel = (data) => {
        console.log(data)
        const createRows = (groups = [], tariffs = []) => {
        const totalRows = Math.max(groups.length, tariffs.length);

        return Array.from({ length: totalRows }, (_, i) => [
                groups[i]?.grp_id ?? "",
                groups[i]?.GRP_DESCRIPTION ?? "",
                tariffs[i]?.tar_id ?? "",
                tariffs[i]?.TAR_DESCRIPTION ?? "",
            ]);
        };

        const dbpicRows = createRows(
            data.dbpicGroups,
            data.dbpicTariffs
        );

        const integraRows = createRows(
            data.integraGroups,
            data.integraTariffs
        );

        const totalRows = Math.max(dbpicRows.length, integraRows.length);

        const rows = [
            ["DBPIC", "", "", "", "INTEGRAMOBILE", "", "", ""],
            [
                "GRP_ID",
                "GRP_DESCRIPTION",
                "TAR_ID",
                "TAR_DESCRIPTION",
                "GRP_ID",
                "GRP_DESCRIPTION",
                "TAR_ID",
                "TAR_DESCRIPTION",
            ],
        ];

        for (let i = 0; i < totalRows; i++) {
            rows.push([
            ...(dbpicRows[i] ?? ["", "", "", ""]),
            ...(integraRows[i] ?? ["", "", "", ""]),
            ]);
        }

        const worksheet = XLSX.utils.aoa_to_sheet(rows);

        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 3 } },
            { s: { r: 0, c: 4 }, e: { r: 0, c: 7 } },
        ];

        worksheet["!cols"] = [
            { wch: 12 },
            { wch: 40 },
            { wch: 12 },
            { wch: 45 },
            { wch: 12 },
            { wch: 40 },
            { wch: 12 },
            { wch: 45 },
        ];

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Groups and Tariffs"
        );

        XLSX.writeFile(workbook, `${selectedIns.ins_description} Groups & Tariffs.xlsx`);
    };

    useEffect(()=>{
        getInstalltions();
    },[])

    return (
        <div>
            <Header />
            <div className="main-container my-3">
                <div className="row m-2">
                    <div className="col-lg-2 col-xl-2 d-none d-lg-block d-xl-block">
                        <Sidenav/>
                    </div>
                    <div className="col-lg-10 col-xl-10">
                        <Paper elevation={2} sx={{ width: '100%', p: 3}}>
                            <Typography variant="body1" className="font-bold">Export</Typography>
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className='col-lg-6'>
                                        <Autocomplete
                                            disablePortal
                                            id="combo-box-demo"
                                            options={installations}
                                            getOptionLabel={(option) => option.ins_description}
                                            name="selectedIns"
                                            value={selectedIns}
                                            onChange={(event, newValue)=>onInsSelect(newValue)}
                                            renderInput={(params) =>
                                            <TextField 
                                                {...params} id="standard-basic" 
                                                label="City" variant="standard" 
                                                className="width-90" 
                                                required
                                            />}
                                    />
                                    </div>
                                    <div className='col-lg-6'>
                                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, gap: 1 }}>
                                            <Box sx={{ flex: '1 1 auto' }} />
                                            <Button type="submit" className="btn btn-blue px-3 fit-content">
                                                Get Groups & Tariffs
                                            </Button>
                                            <Button type="button" className="btn btn-blue px-3 fit-content" onClick={() => exportToExcel(data)} disabled={allArraysEmpty(data)}>
                                                Export
                                            </Button>
                                        </Box>
                                    </div>
                                </div>
                            </form>
                            {!allArraysEmpty(data) && <div className="mt-3">
                                <div className="row">
                                    <TableCard
                                        title="DBPIC"
                                        groups={data.dbpicGroups}
                                        tariffs={data.dbpicTariffs}
                                    />

                                    <TableCard
                                        title="INTEGRA"
                                        groups={data.integraGroups}
                                        tariffs={data.integraTariffs}
                                    />
                                </div>
                            </div>}
                        </Paper>
                    </div>
                </div>
            </div>
            <Spinner
                spinner = {spinner}
            />
            <SnackAlert 
                msg={msg}
                alert={alert}
                severity={severity}

                closeAlert={()=>setAlert(false)}
            />
        </div>
    );
}

const TableCard = ({ title, groups, tariffs }) => {
  const totalRows = Math.max(
    groups?.length || 0,
    tariffs?.length || 0
  );

  return (
    <div className="col-md-6 mb-3">
      <div className="card shadow-sm">
        <div className="card-header text-white bg-blue fw-bold">
          {title}
        </div>

        <div className="card-body p-0">
          <div style={{ overflowX: "auto" }}>
            <table className="table table-bordered table-striped mb-0">
              <thead>
                <tr>
                  <th>GRP_ID</th>
                  <th>GRP_DESCRIPTION</th>
                  <th>TAR_ID</th>
                  <th>TAR_DESCRIPTION</th>
                </tr>
              </thead>

              <tbody>
                {Array.from({ length: totalRows }, (_, index) => {
                  const group = groups?.[index];
                  const tariff = tariffs?.[index];

                  return (
                    <tr key={index}>
                      <td>{group?.grp_id ?? ""}</td>
                      <td>{group?.GRP_DESCRIPTION ?? ""}</td>
                      <td>{tariff?.tar_id ?? ""}</td>
                      <td>{tariff?.TAR_DESCRIPTION ?? ""}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};